import React, { useState } from "react";
import { Box, Modal, Typography, IconButton, SvgIcon } from "@mui/material";
import {
  GridView,
  Close,
  KeyboardArrowRight,
  KeyboardArrowLeft,
} from "@mui/icons-material";
import ButtonNew from "../../../common/components/button-new/button-new";
import { ReactComponent as NoImgIcon } from "../../../assets/icons/no-img-icon.svg";
import "./PlannerImageGallery.scss";

const PlannerImageGallery: React.FC<any> = ({ images, providerTitle = "" }) => {
  // Extract valid image URLs
  const imageUrls =
    images
      ?.filter((item: any) => item.mediaType === "image" && item.url)
      .map((item: any) => item.url) || [];

  const noImages = imageUrls?.length === 0;
  const singleImage = imageUrls?.length === 1;
  const imageCount = imageUrls?.length;

  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleOpen = (index: number) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handlePrev = () =>
    setCurrentIndex((prev) => (prev === 0 ? imageUrls.length - 1 : prev - 1));

  const handleNext = () =>
    setCurrentIndex((prev) => (prev === imageUrls.length - 1 ? 0 : prev + 1));

  const currentImage = imageUrls[currentIndex];
  const counter = `${currentIndex + 1}/${imageUrls.length}`;

  return (
    <>
      <Box className="planner-gallery">
        {noImages ? (
          <Box className="planner-gallery__empty">
            <SvgIcon
              component={NoImgIcon}
              style={{ height: "96px", width: "96px" }}
              inheritViewBox
            />
            <Typography>No images available</Typography>
          </Box>
        ) : (
          <>
            {/* IMAGE GRID */}
            {singleImage ? (
              <Box className="planner-gallery__single">
                <img
                  src={imageUrls[0]}
                  alt="Single"
                  onClick={() => handleOpen(0)}
                />
              </Box>
            ) : (
              <Box
                className={`planner-gallery__grid planner-gallery__grid--${Math.min(
                  imageCount,
                  3,
                )}`}
              >
                <Box className="planner-gallery__main-image">
                  <img
                    src={imageUrls[0]}
                    alt="Main"
                    onClick={() => handleOpen(0)}
                  />
                </Box>
                {imageCount > 1 && (
                  <Box className="planner-gallery__side-images">
                    {imageUrls.slice(1, 3).map((url: string, idx: number) => (
                      <Box key={idx} className="planner-gallery__side-image">
                        <img
                          src={url}
                          alt={`Gallery ${idx + 1}`}
                          onClick={() => handleOpen(idx + 1)}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}

            {/* SHOW ALL BUTTON */}
            {imageCount > 3 && (
              <Box className="planner-gallery__footer">
                <ButtonNew
                  text="Show all photos"
                  icon={<GridView />}
                  iconPosition="left"
                  bgColor="#FFFFFF"
                  textColor="#000000"
                  borderColor="#000000"
                  iconColor="#000000"
                  onClick={() => handleOpen(0)}
                  className="planner-gallery__button"
                />
              </Box>
            )}
          </>
        )}
      </Box>

      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        className="planner-gallery__modal"
      >
        <Box className="planner-gallery-modal">
          <Box className="planner-gallery-modal__header">
            <Typography variant="h6" className="planner-gallery-modal__title">
              Pictures of - {providerTitle}
            </Typography>
            <IconButton
              onClick={handleClose}
              className="planner-gallery-modal__close"
            >
              <Close />
            </IconButton>
          </Box>

          <img
            src={currentImage}
            alt={providerTitle}
            className="planner-gallery-modal__image"
          />

          {/* NAV LEFT */}
          <IconButton
            onClick={handlePrev}
            className="planner-gallery-modal__nav-left"
          >
            <KeyboardArrowLeft fontSize="small" />
          </IconButton>

          {/* NAV RIGHT */}
          <IconButton
            onClick={handleNext}
            className="planner-gallery-modal__nav-right"
          >
            <KeyboardArrowRight fontSize="small" />
          </IconButton>

          {/* COUNTER */}
          <Typography
            variant="body2"
            className="planner-gallery-modal__counter"
          >
            {counter}
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default PlannerImageGallery;
